module.exports = __webpack_public_path__ + "Icon_Brick Levels.0b10c6cac2af37964c76.png";